export { default } from "./TabContext.js";
export * from "./TabContext.js";